<div class="pre-header" [ngClass]="{ 'pre-header--dark': data.isDark }">
  <div class="pre-header__container" [innerHTML]="data.content?.processed"></div>
</div>
